import type { DateRange } from 'react-day-picker';

export enum TimeRange {
  Today = 'today',
  Yesterday = 'yesterday',
  ThisWeek = 'thisWeek',
  LastWeek = 'lastWeek',
  Custom = 'custom',
}

export function getDateRange(range: TimeRange): DateRange {
  const now = new Date();
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());

  switch (range) {
    case TimeRange.Today:
      return { from: today, to: today };
    case TimeRange.Yesterday: {
      const yesterday = new Date(today);
      yesterday.setDate(yesterday.getDate() - 1);
      return { from: yesterday, to: yesterday };
    }
    case TimeRange.ThisWeek: {
      const firstDayOfWeek = new Date(today);
      const day = firstDayOfWeek.getDay(); // 0 (Sun) to 6 (Sat)
      const diff = firstDayOfWeek.getDate() - day + (day === 0 ? -6 : 1); // Adjust for Monday start
      firstDayOfWeek.setDate(diff);
      const lastDayOfWeek = new Date(firstDayOfWeek);
      lastDayOfWeek.setDate(lastDayOfWeek.getDate() + 6);
      return { from: firstDayOfWeek, to: lastDayOfWeek };
    }
    case TimeRange.LastWeek: {
      const firstDayOfLastWeek = new Date(today);
      const day = firstDayOfLastWeek.getDay();
      const diff = firstDayOfLastWeek.getDate() - day + (day === 0 ? -6 : 1) - 7;
      firstDayOfLastWeek.setDate(diff);
      const lastDayOfLastWeek = new Date(firstDayOfLastWeek);
      lastDayOfLastWeek.setDate(lastDayOfLastWeek.getDate() + 6);
      return { from: firstDayOfLastWeek, to: lastDayOfLastWeek };
    }
    default:
      return { from: today, to: today };
  }
}
